module.exports = __webpack_public_path__ + "img/DSC_0030.f440bcae.jpeg";